// Categorización IA de un producto — flujo migrado de n8n al backend nuevo.
//
// Fire-and-forget SIEMPRE: la categorización no es crítica, ningún caller lee
// la respuesta (el backend nuevo devuelve 202 {ok, response, job_id}) y un
// fallo acá jamás debe romper el alta/edición del producto. Por eso este
// helper no lanza ni devuelve nada.
//
// Flag de rollback (VITE_USE_ATLAS_BACKEND):
//  • ON  → POST {ATLAS_BACKEND_URL}/v1/products/categorize con JWT de Supabase
//          y body { product_id, modo?, completar_nombre? } — sin user_id (el
//          backend lo deriva del token). `completar_nombre` viaja como boolean
//          REAL (el backend valida tipos).
//  • OFF → POST al webhook viejo de n8n con GENERATE_AUTH_TOKEN + user_id,
//          exactamente como antes de la migración.
//
// Los campos opcionales se OMITEN del body cuando no vienen (ej. el alta de
// onboarding manda solo product_id — mantener así).

import { atlasBackendFetch } from './atlasBackend';
import { GENERATE_AUTH_TOKEN, USE_ATLAS_BACKEND } from '../config';

const N8N_CATEGORIZAR_URL =
  'https://ai-agency-dt7d.onrender.com/webhook/categorizar_producto';

export function categorizeProduct(
  productId: string,
  opts: {
    modo?: 'crear' | 'editar';
    /** true = el user no puso nombre y el backend lo completa con IA. */
    completarNombre?: boolean;
    /** Solo para el fallback n8n (el backend nuevo usa el JWT). */
    userId?: string;
  } = {},
): void {
  const { modo, completarNombre, userId } = opts;

  if (USE_ATLAS_BACKEND) {
    const body: Record<string, unknown> = { product_id: productId };
    if (modo !== undefined) body.modo = modo;
    if (completarNombre !== undefined)
      body.completar_nombre = Boolean(completarNombre);
    atlasBackendFetch('/v1/products/categorize', body).catch(() => {
      /* silent — categorización IA no es crítica */
    });
    return;
  }

  // Rollback: webhook n8n, mismo body que antes de la migración.
  const body: Record<string, unknown> = {
    user_id: userId,
    product_id: productId,
  };
  if (modo !== undefined) body.modo = modo;
  if (completarNombre !== undefined)
    body.completar_nombre = Boolean(completarNombre);
  try {
    fetch(N8N_CATEGORIZAR_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: GENERATE_AUTH_TOKEN,
      },
      body: JSON.stringify(body),
    }).catch(() => {
      /* noop */
    });
  } catch {
    /* noop */
  }
}
